import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["brandSelect"]
  static values = { brands: Object }

  filter(event) {
    const clientId = event.target.value
    const brands = clientId ? (this.brandsValue[clientId] || []) : []
    const select = this.brandSelectTarget

    // Save current selection
    const current = select.value

    select.innerHTML = '<option value="">All brands</option>'
    brands.forEach(b => {
      const opt = document.createElement("option")
      opt.value = b.id
      opt.textContent = b.name
      if (String(b.id) === current) opt.selected = true
      select.appendChild(opt)
    })

    select.disabled = brands.length === 0
  }
}
